import { render, staticRenderFns } from "./MiniProgramConfig.vue?vue&type=template&id=0dbdd038&scoped=true&"
import script from "./MiniProgramConfig.vue?vue&type=script&lang=ts&"
export * from "./MiniProgramConfig.vue?vue&type=script&lang=ts&"
import style0 from "./MiniProgramConfig.vue?vue&type=style&index=0&id=0dbdd038&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbdd038",
  null
  
)

export default component.exports